import React from 'react';

// Small pill/tag label — PAID, LOCKED, TITLE FIGHT, etc.
function CardChip({ tone = 'mute', children }) {
  return <span className={`pnp-chip pnp-chip-${tone}`}>{children}</span>;
}

export default CardChip;
